import { all, takeLatest, call, put } from 'redux-saga/effects';
import { UsersInstance } from '@/services/membership/users';
import { getUserInfoActions, updateUserInfoActions, updateUserPasswordActions } from '@/redux/actions/membership/users';
import { ActionType } from 'deox';
import { IdentityUsersInstance } from '@/services/identity/users';

export function* getUserInfoSaga() {
  try {
    const {
      data: { email, memberships, userId, firstName, lastName },
    } = yield call(UsersInstance.getUserInfo);
    yield put(getUserInfoActions.success(email, memberships, userId, firstName, lastName));
  } catch (err) {
    yield put(getUserInfoActions.failure(err));
  }
}

export function* updateUserInfoSaga(action: ActionType<typeof updateUserInfoActions.request>) {
  const { firstName: firstNameRequest, lastName: lastNameRequest, userId: userIdRequest } = action.payload;
  try {
    const {
      data: { email, memberships, userId, firstName, lastName },
    } = yield call(UsersInstance.updateUserInfo, firstNameRequest, lastNameRequest, userIdRequest);
    yield put(updateUserInfoActions.success());
    yield put(getUserInfoActions.success(email, memberships, userId, firstName, lastName));
  } catch (err) {
    yield put(updateUserInfoActions.failure(err));
  }
}

export function* updateUserPasswordSaga(action: ActionType<typeof updateUserPasswordActions.request>) {
  const { password, currentPassword } = action.payload;
  try {
    yield call(IdentityUsersInstance.updateUserPassword, currentPassword, password);
    yield put(updateUserPasswordActions.success());
  } catch (err) {
    yield put(updateUserPasswordActions.failure(err));
  }
}

export default function* root() {
  yield all([takeLatest(getUserInfoActions.request, getUserInfoSaga)]);
  yield all([takeLatest(updateUserInfoActions.request, updateUserInfoSaga)]);
  yield all([takeLatest(updateUserPasswordActions.request, updateUserPasswordSaga)]);
}
